import { render, staticRenderFns } from "./DiscountList.vue?vue&type=template&id=3b0aea9c&scoped=true&lang=pug&"
import script from "./DiscountList.vue?vue&type=script&lang=js&"
export * from "./DiscountList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountList.vue?vue&type=style&index=0&id=3b0aea9c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0aea9c",
  null
  
)

export default component.exports